"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const subscribable_1 = __importDefault(require("./subscribable"));
const util_1 = require("../services/util");
class SiteGroup extends subscribable_1.default {
    constructor(dataService, initParams) {
        super(dataService, initParams.id);
        this.sites = null;
        this.objectTypeName = 'siteGroup';
        this._name = initParams.name;
        this._dataTypes = (0, util_1.camelArray)(initParams.data_types);
        this._widgetBoardId = initParams.widget_board_id;
        this._totalDemand = initParams.total_demand;
        this._issueIds = (0, util_1.camelArray)(initParams.issue_ids);
        this._siteIds = (0, util_1.camelArray)(initParams.site_ids);
        this._disconnectedAssetsViaHub = initParams.disconnected_assets_via_hub;
        this._issues = initParams.issues;
        this._appliances = initParams.appliances;
        this._lowBatteryAssets = initParams.low_battery_assets;
        this._lowSignalAssets = initParams.low_signal_assets;
        this._assetsWithIssues = initParams.assets_with_issues;
        this._faultyAssets = initParams.faulty_assets;
        this._intermittentAssets = initParams.intermittent_assets;
        this._anomalousAssets = initParams.anomalous_assets;
        this.__permission = initParams._permission;
    }
    set name(value) {
        console.error('Do not set objects this way');
    }
    setName(value) {
        return this.dataService.updateSiteGroup(this.id, { name: value }, this);
    }
    get name() {
        return this._name;
    }
    set dataTypes(value) {
        console.error('Do not set objects this way');
    }
    setDataTypes(value) {
        return this.dataService.updateSiteGroup(this.id, { data_types: (0, util_1.snakeArray)(value) }, this);
    }
    get dataTypes() {
        return this._dataTypes;
    }
    set widgetBoardId(value) {
        console.error('Do not set objects this way');
    }
    setWidgetBoardId(value) {
        return this.dataService.updateSiteGroup(this.id, { widget_board_id: value }, this);
    }
    get widgetBoardId() {
        return this._widgetBoardId;
    }
    set totalDemand(value) {
        console.error('Do not set objects this way');
    }
    setTotalDemand(value) {
        return this.dataService.updateSiteGroup(this.id, { total_demand: value }, this);
    }
    get totalDemand() {
        return this._totalDemand;
    }
    set issueIds(value) {
        console.error('Do not set objects this way');
    }
    setIssueIds(value) {
        return this.dataService.updateSiteGroup(this.id, { issue_ids: (0, util_1.snakeArray)(value) }, this);
    }
    get issueIds() {
        return this._issueIds;
    }
    set siteIds(value) {
        console.error('Do not set objects this way');
    }
    setSiteIds(value) {
        return this.dataService.updateSiteGroup(this.id, { site_ids: (0, util_1.snakeArray)(value) }, this);
    }
    get siteIds() {
        return this._siteIds;
    }
    set disconnectedAssetsViaHub(value) {
        console.error('Do not set objects this way');
    }
    setDisconnectedAssetsViaHub(value) {
        return this.dataService.updateSiteGroup(this.id, { disconnected_assets_via_hub: value }, this);
    }
    get disconnectedAssetsViaHub() {
        return this._disconnectedAssetsViaHub;
    }
    set issues(value) {
        console.error('Do not set objects this way');
    }
    setIssues(value) {
        return this.dataService.updateSiteGroup(this.id, { issues: value }, this);
    }
    get issues() {
        return this._issues;
    }
    set appliances(value) {
        console.error('Do not set objects this way');
    }
    setAppliances(value) {
        return this.dataService.updateSiteGroup(this.id, { appliances: value }, this);
    }
    get appliances() {
        return this._appliances;
    }
    set lowBatteryAssets(value) {
        console.error('Do not set objects this way');
    }
    setLowBatteryAssets(value) {
        return this.dataService.updateSiteGroup(this.id, { low_battery_assets: value }, this);
    }
    get lowBatteryAssets() {
        return this._lowBatteryAssets;
    }
    set lowSignalAssets(value) {
        console.error('Do not set objects this way');
    }
    setLowSignalAssets(value) {
        return this.dataService.updateSiteGroup(this.id, { low_signal_assets: value }, this);
    }
    get lowSignalAssets() {
        return this._lowSignalAssets;
    }
    set assetsWithIssues(value) {
        console.error('Do not set objects this way');
    }
    setAssetsWithIssues(value) {
        return this.dataService.updateSiteGroup(this.id, { assets_with_issues: value }, this);
    }
    get assetsWithIssues() {
        return this._assetsWithIssues;
    }
    set faultyAssets(value) {
        console.error('Do not set objects this way');
    }
    setFaultyAssets(value) {
        return this.dataService.updateSiteGroup(this.id, { faulty_assets: value }, this);
    }
    get faultyAssets() {
        return this._faultyAssets;
    }
    set intermittentAssets(value) {
        console.error('Do not set objects this way');
    }
    setIntermittentAssets(value) {
        return this.dataService.updateSiteGroup(this.id, { intermittent_assets: value }, this);
    }
    get intermittentAssets() {
        return this._intermittentAssets;
    }
    set anomalousAssets(value) {
        console.error('Do not set objects this way');
    }
    setAnomalousAssets(value) {
        return this.dataService.updateSiteGroup(this.id, { anomalous_assets: value }, this);
    }
    get anomalousAssets() {
        return this._anomalousAssets;
    }
    set _permission(value) {
        console.error('Do not set objects this way');
    }
    set_permission(value) {
        return this.dataService.updateSiteGroup(this.id, { _permission: value }, this);
    }
    get _permission() {
        return this.__permission;
    }
    set(object) {
        let updateObject = (0, util_1.snakeObject)(object);
        let self = this;
        return this.dataService.updateSiteGroup(this.id, updateObject, this)
            .then(function (res) {
            Object.keys(object).forEach(function (key) {
                self['_' + key] = object[key];
            });
            return Promise.resolve(res);
        });
    }
    delete() {
        return this.dataService.deleteSiteGroup(this.id, this);
    }
}
exports.default = SiteGroup;
//# sourceMappingURL=siteGroup.js.map